export enum RoomTypes {
  GIG = 1,
  JOB = 2,
  VACANCY = 3,
  TET_A_TET = 4,
  MULTI = 5,
}
